// -----------------------------------------------------------------------------------------
// en product__main.liquid añado uno script donde paso todo el producto como dato, id="pangoProductData"
// DATOS 
// -----------------------------------------------------------------------------------------
const productData = JSON.parse(document.getElementById('pangoProductData').textContent);
const variantsData = productData.variants;

const variants = {};
variantsData.forEach(function(variant) {
  variants[variant.id] = {
    grams: convertToInteger(variant.title),
    price: variant.price/100
  };
});
// -----------------------------------------------------------------------------------------
// FUNCIONES AL CARGAR LA PAGINA Y AL CLICAR VARIANTE
// -----------------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  // cuando carga pagina
  updatePricePerGram();  
  displayEnvioGratuito();

  // cuando click variante
  document.querySelector('[name="id"]').addEventListener('change', function() {
    updatePricePerGram();
    displayEnvioGratuito();
  });

});

// -----------------------------------------------------------------------------------------
// PRECIO POR GRAMO
// -----------------------------------------------------------------------------------------
function convertToInteger(weightString) {
  let numericString = weightString.replace(/\D/g, '');
  let weight = parseInt(numericString, 10);
  return weight;
}
function updatePricePerGram() {  
  let selectedVariantId = document.querySelector('[name="id"]').value;
  let variant = variants[selectedVariantId];
  if (variant) {
    let grams = parseFloat(variant.grams.replace(',', '.')); 
    if (!isNaN(grams) && grams > 0) {
      let pricePerGram = (variant.price / grams).toFixed(2);
      if (!isNaN(pricePerGram)) { 
        document.getElementById('price-per-gram').textContent = 'Tu gramo a ' + pricePerGram + '€';      
      }
    }
  }
}

// -----------------------------------------------------------------------------------------
// ENVIO GRATIS
// -----------------------------------------------------------------------------------------
function displayEnvioGratuito(){
  let enviogratuitoElement = document.querySelector('.envio-gratis')
  var selectedVariantId = document.querySelector('[name="id"]').value;
  var variantData = variants[selectedVariantId];
  if (variantData) {
    var price = variantData.price;
    if (price > 20){
      enviogratuitoElement.style.display="flex";
    } else {
      enviogratuitoElement.style.display="none";                        
    }
  }
}

// -----------------------------------------------------------------------------------------
//  
// -----------------------------------------------------------------------------------------